
import { FETCH_SasData_SUCCESS, FETCH_SasData_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  sasData: [],
  error: null,
  redirectToLoginPage: false,
};

const SasDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SasData_SUCCESS:
      return {
        ...state,
        sasData: action.payload.sasData,
        error: null,
      };
    case FETCH_SasData_FAILURE:
      return {
        ...state,
        sasData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default SasDataReducer;
